import { Box, Button, Typography, Skeleton } from "@mui/material";
import RateReviewIcon from "@mui/icons-material/RateReview";
import { formatCurrency } from "../../utils/currency";
import theme from "../../styles/styleTheme";

interface SubmittedScreeningViewProps {
  property: any;
  screeningData: any;
  onGoogleReview: () => void;
}

const SubmittedScreeningView = ({ property, screeningData, onGoogleReview }: SubmittedScreeningViewProps) => {
  return (
    <>
      <Box
        sx={{
          padding: "1rem",
          margin: "1rem",
          marginLeft: 0,
        }}
      >
        {property ? (
          <>
            <Typography variant="h1">
              {property?.title}
            </Typography>
            <Typography>
              {formatCurrency(property?.propertyDetails?.minimumRent)} / mnd
            </Typography>
          </>
        ) : (
          <>
            <Skeleton variant="text" height={30} width={250} />
            <Skeleton variant="text" height={20} width={150} />
          </>
        )}
      </Box>
      <Box>
        <Box
          sx={{
            padding: "1rem",
            margin: "1rem",
            backgroundColor: "#ccf",
            borderLeft: "10px solid #33f",
          }}
        >
          <Typography variant="h4">
            Screening in behandeling
          </Typography>
          <Typography>
            Uw screening is ingediend en wordt behandeld. U wordt
            op de hoogte gehouden via de e-mail.
          </Typography>
        </Box>
        {screeningData?.candidate?.review >= 4 && (
          <Box paddingBottom={"1rem"} marginLeft={"1rem"}>
            <Typography>
              Zou je een moment willen nemen om je ervaring met
              ons te delen in een Google Review? Jouw feedback
              helpt ons om onze dienstverlening te verbeteren en
              anderen te helpen bij het vinden van hun huurwoning.
            </Typography>

            <Box
              width={"100%"}
              display={"flex"}
              justifyContent={"flex-start"}
            >
              <Button
                color="secondary"
                onClick={onGoogleReview}
                sx={{
                  marginRight: "1rem",
                  marginTop: 1,
                  padding: 1.4,
                  borderRadius: 14,
                  background: theme.palette.secondary.light,
                }}
                endIcon={<RateReviewIcon />}
              >
                Plaats een review
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default SubmittedScreeningView; 